"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const types_1 = require("./types");
const Error_1 = __importDefault(require("../icons/Error"));
const Info_1 = __importDefault(require("../icons/Info"));
const Tick_1 = __importDefault(require("../icons/Tick"));
const accessibility_1 = require("../../../../shared/accessibility");
const atoms_1 = require("../../atoms");
const S = __importStar(require("./Toast.styles"));
const toastStyle = {
    [types_1.ToastType.SUCCESS]: {
        backgroundColor: '#e6fff2',
        borderColor: '#2ee68c',
    },
    [types_1.ToastType.ERROR]: {
        backgroundColor: '#ffedf0',
        borderColor: '#ff7591',
    },
    [types_1.ToastType.INFO]: {
        backgroundColor: '#ecfafe',
        borderColor: '#4fc3f7',
    },
    [types_1.ToastType.WARNING]: {
        backgroundColor: '#fff3cd',
        borderColor: '#ffeeba',
    },
};
const toastIcon = {
    [types_1.ToastType.SUCCESS]: react_1.default.createElement(Tick_1.default, null),
    [types_1.ToastType.INFO]: react_1.default.createElement(Info_1.default, null),
    [types_1.ToastType.ERROR]: react_1.default.createElement(Error_1.default, null),
    [types_1.ToastType.WARNING]: react_1.default.createElement(Error_1.default, null),
};
// eslint-disable-next-line sonarjs/cognitive-complexity
const ToastUI = (props) => {
    const { id, onDestroy, type = types_1.ToastType.INFO, message, duration = 4000, style, animationDuration = 250, animationType = 'slide-in', placement = types_1.ToastPlacement.TOP, swipeEnabled = true, onPress, open, } = props;
    const containerRef = react_1.useRef(null);
    const [animation] = react_1.useState(new react_native_1.Animated.Value(0));
    const panResponderRef = react_1.useRef();
    const panResponderAnimRef = react_1.useRef();
    const closeTimeoutRef = react_1.useRef(null);
    const dims = react_native_1.Dimensions.get('window');
    const handleClose = () => {
        react_native_1.Animated.timing(animation, {
            toValue: 0,
            useNativeDriver: react_native_1.Platform.OS !== 'web',
            duration: animationDuration,
        }).start(() => onDestroy && onDestroy());
    };
    react_1.useEffect(() => {
        react_native_1.Animated.timing(animation, {
            toValue: 1,
            useNativeDriver: react_native_1.Platform.OS !== 'web',
            duration: animationDuration,
        }).start();
        if (duration !== 0 && typeof duration === 'number') {
            closeTimeoutRef.current = setTimeout(() => {
                handleClose();
            }, duration);
        }
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
        };
    }, [duration]);
    react_1.useEffect(() => {
        if (!open) {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
            handleClose();
        }
    }, [open]);
    const getPanResponderAnim = () => {
        if (panResponderAnimRef.current) {
            return panResponderAnimRef.current;
        }
        panResponderAnimRef.current = new react_native_1.Animated.ValueXY({ x: 0, y: 0 });
        return panResponderAnimRef.current;
    };
    const panReleaseToLeft = (gestureState) => {
        react_native_1.Animated.timing(getPanResponderAnim(), {
            toValue: { x: (-dims.width / 10) * 9, y: gestureState.dy },
            useNativeDriver: react_native_1.Platform.OS !== 'web',
            duration: 250,
        }).start(() => onDestroy && onDestroy());
    };
    const panReleaseToRight = (gestureState) => {
        react_native_1.Animated.timing(getPanResponderAnim(), {
            toValue: { x: (dims.width / 10) * 9, y: gestureState.dy },
            useNativeDriver: react_native_1.Platform.OS !== 'web',
            duration: 250,
        }).start(() => onDestroy && onDestroy());
    };
    const getPanResponder = () => {
        if (panResponderRef.current)
            return panResponderRef.current;
        panResponderRef.current = react_native_1.PanResponder.create({
            onMoveShouldSetPanResponder: (_, gestureState) => {
                return !(gestureState.dx === 0 && gestureState.dy === 0);
            },
            onPanResponderMove: (_, gestureState) => {
                getPanResponderAnim()?.setValue({
                    x: gestureState.dx,
                    y: gestureState.dy,
                });
            },
            onPanResponderRelease: (_, gestureState) => {
                if (gestureState.dx > 50) {
                    panReleaseToRight(gestureState);
                }
                else if (gestureState.dx < -50) {
                    panReleaseToLeft(gestureState);
                }
                else {
                    react_native_1.Animated.spring(getPanResponderAnim(), {
                        toValue: { x: 0, y: 0 },
                        useNativeDriver: react_native_1.Platform.OS !== 'web',
                    }).start();
                }
            },
        });
        return panResponderRef.current;
    };
    const animationStyle = {
        opacity: animation,
        transform: [
            {
                translateY: animation.interpolate({
                    inputRange: [0, 1],
                    outputRange: placement === 'bottom' ? [20, 0] : [-20, 0],
                }),
            },
        ],
    };
    if (swipeEnabled) {
        animationStyle.transform?.push(getPanResponderAnim().getTranslateTransform()[0]);
    }
    if (animationType === 'zoom-in') {
        animationStyle.transform?.push({
            scale: animation.interpolate({
                inputRange: [0, 1],
                outputRange: [0.7, 1],
            }),
        });
    }
    return (react_1.default.createElement(react_native_1.Animated.View, Object.assign({ testID: "animatedView", ref: containerRef }, (swipeEnabled ? getPanResponder().panHandlers : null), { style: animationStyle }),
        react_1.default.createElement(react_native_1.TouchableWithoutFeedback, Object.assign({ accessibilityRole: "button" }, accessibility_1.accessibilityProps(`${type}-toast`), { disabled: !onPress, onPress: () => onPress && onPress(id) }),
            react_1.default.createElement(S.ToastContainer, { style: [
                    {
                        width: dims.width - 48,
                        ...toastStyle[type],
                    },
                    style,
                ] },
                react_1.default.createElement(S.ToastIconContainer, null, toastIcon[type]),
                react_1.default.createElement(S.ToastTextContainer, null,
                    react_1.default.createElement(S.ToastText, Object.assign({ type: atoms_1.PTextLightType.LEAD }, accessibility_1.accessibilityProps(`${type}-toast-text`)), message))))));
};
exports.default = ToastUI;
